<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
	min-height: 100vh;
    height: auto;
    position: relative;
    min-width: 290px;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue